/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportDetails {
    getFixupPrototypeFunction() { return ReportDetails.fixupPrototype; }

    static newInstance(model: Partial<ReportDetails>): ReportDetails {
        let obj = Object.assign(new ReportDetails(), model);
        ReportDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportDetails>): ReportDetails {
        if (!model) return null;
        return ReportDetails.newInstance(<ReportDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportDetails) {
        if (!obj) return;

        models.ReportDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportDetails): boolean {
        Object.setPrototypeOf(obj, ReportDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.views) {
            for (let val of this.views) {
                models.ReportViewDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the report
     */
    report_id: string;

    /**
     * List of Views
     */
    views: Array<models.ReportViewDetails>;

}
